import { Divider } from "../../../../components";
import { useLoanApplication } from "../../../../contexts";
import { toTitleCase } from "../../../../utils";
import LoanReviewField from "../LoanReviewField";
import EditButton from "../EditButton";
import { BusinessInformationModal } from "../BusinessInformationModal";
import { useState } from "react";
import { useDpConfig } from "../../../../contexts/dpConfig";
import { useLoanProductConfigFlags } from "../../../../hooks/useLoanProductConfigFlags";

const BusinessInformationReviewSection = () => {
  const { state } = useLoanApplication();
  const { additionalData } = useDpConfig().state.settings;

  const { disableRevenueHistory } = useLoanProductConfigFlags(state.loanType!);

  const [isEditModalOpen, setIsEditModalOpen] = useState<boolean>(false);

  return (
    <div className="cx-bg-white cx-rounded-lg cx-w-full cx-max-w-full cx-shadow-md cx-p-4 sm:cx-p-5 md:cx-p-10 cx-mt-10">
      <div className="cx-flex cx-flex-row cx-items-center cx-justify-between cx-gap-2 cx-w-full cx-min-w-0">
        <div className="cx-min-w-0 cx-flex-1 cx-text-base md:cx-text-xl cx-font-bold cx-leading-snug">
          Business
          <br />
          Information
        </div>
        <div className="cx-shrink-0">
          <EditButton onClick={() => setIsEditModalOpen(true)} />
        </div>
        <BusinessInformationModal
          isOpen={isEditModalOpen}
          onClose={() => setIsEditModalOpen(false)}
          disableRevenueHistory={disableRevenueHistory ?? true}
        />
      </div>
      <div className="cx-flex cx-flex-col sm:cx-flex-row cx-gap-x-10">
        <div className="cx-flex cx-flex-col cx-grow cx-basis-0">
          <LoanReviewField value={state.businessName} label="Company name" />
          <Divider />
          <LoanReviewField
            value={toTitleCase(state.businessType)}
            label="Business type"
          />
          <Divider />
          <LoanReviewField
            value={toTitleCase(state.licensingAuthorityId) ?? ""}
            label="Licensing authority"
          />
          <Divider />
          <LoanReviewField
            value={
              state.loanPurpose === "OTHERS"
                ? state.loanPurposeDescription ?? ""
                : toTitleCase(state.loanPurpose ?? "")
            }
            label="Intended use of funds"
          />
          <Divider />
          {additionalData?.map((field) => (
            <div key={field.key}>
              <Divider />
              <LoanReviewField
                value={
                  state.additionalDPMetadata
                    ? state.additionalDPMetadata[field.key]
                    : ""
                }
                label={field.displayName}
              />
            </div>
          ))}
          {!disableRevenueHistory && !!state.lastYearPaidTax && (
            <>
              <Divider />
              <LoanReviewField
                value={
                  state.lastYearPaidTax ? (
                    <span className="cx-inline-flex cx-items-center cx-gap-1">
                      <div className="cx-font-aed-font"> D </div>
                      {state.lastYearPaidTax.toLocaleString()}
                    </span>
                  ) : (
                    ""
                  )
                }
                label="Total tax paid in previous year"
              />
            </>
          )}
          <Divider mobileOnly />
        </div>
        <div className="cx-flex cx-flex-col cx-grow cx-basis-0">
          <LoanReviewField
            value={state.businessYearEstabilished}
            label="Year company established"
          />
          <Divider />
          <LoanReviewField
            value={state.tradeLicenseNumber}
            label="Trade license number"
          />
          <Divider />
          {!disableRevenueHistory && (
            <LoanReviewField
              value={
                <span className="cx-inline-flex cx-items-center cx-gap-1">
                  <div className="cx-font-aed-font"> D </div>
                  {state.annualRevenue.toLocaleString()}
                </span>
              }
              label="Annual revenue"
            />
          )}
          {!disableRevenueHistory && !!state.taxRegistrationNumber && (
            <>
              <Divider />
              <LoanReviewField
                value={state.taxRegistrationNumber}
                label="Tax registration number"
              />
            </>
          )}
          <Divider />
          <LoanReviewField
            value={`
                ${state.businessFloor} - ${state.businessUnit} 
                ${state.businessBuilding}
                ${state.businessArea} 
                ${state.businessEmirate}
                `}
            label="Office address"
          />
        </div>
      </div>
    </div>
  );
};

export default BusinessInformationReviewSection;
